const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const CookieManagementQuery: any = {
    ListOfCookie: Backofficebff + '/v1/cookiemanagement/list-of-cookie',
    ListOfGroupByTypeId: Backofficebff + '/v1/cookiemanagement/list-of-cookie-group-by-type-id',
    ListOfCookieType: Backofficebff + '/v1/cookiemanagement/list-of-cookie-type',
};
